import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M 21,7.82845 V 16 H 12.8284 L 15.5562,13.2722 13.1996,11.995 C 11.6535,11.1571 9.47666,10.5 7.00004,10.5 5.9748,10.5 4.88029,10.5849 3.8601,10.9374 5.02768,9.36504 7.07537,8.00002 11,8.00002 c 2.6784,0 5.4094,0.51901 7.4254,1.02621 l 1.1,0.27677 z M 2.02111,17.0627 C 2.02591,17.0317 2.02944,17.0003 2.03163,16.9686 2.28147,13.3509 4.00777,12.5 7.00004,12.5 c 1.17961,0 2.27225,0.174 3.22666,0.4449 0.7731,0.2195 1.4555,0.5026 2.0199,0.8085 L 9.7071,16.2929 C 9.07713,16.9229 9.5233,18 10.4142,18 H 22 c 0.5523,0 1,-0.4477 1,-1 V 5.41424 C 23,4.52333 21.9228,4.07716 21.2929,4.70713 L 18.9133,7.08667 C 16.8181,6.55953 13.9091,6.00002 11,6.00002 1.79746,6.00002 0.216719,12.775 0.0231249,16.9728 -0.00284752,17.536 0.465826,17.9863 1.02937,17.9698 1.53745,17.9549 1.94285,17.5603 2.02075,17.065 Z"
  }));
});
var DescriptiveSkip = AbstractIcon.withComponent(Icon);
DescriptiveSkip.displayName = 'DescriptiveSkip';
export default DescriptiveSkip;